import styled from 'styled-components'

import {
  Text,
  InlineChildren,
  Spacing,
  StackChildren,
} from '@doordash/design-language'

export const TopCitiesContainer = styled(StackChildren)`
  display: flex;
  width: 100vw;
  padding: ${Spacing.XxxxLarge}px 0 ${Spacing.XxLarge}px 0;
  background: #f4fdff;
`

export const TopCitiesTitleContainer = styled.div`
  width: 100vw;
  text-align: center;
  padding: ${Spacing.Large}px;
`

export const TopCitiesTitle = styled(Text)``

type MobileProps = {
  mobile: boolean
}

export const CitiesContainer = styled(InlineChildren)`
  padding: ${(props: MobileProps) =>
    props.mobile
      ? `0 ${Spacing.XxLarge}px ${Spacing.Large}px ${Spacing.XxLarge}px`
      : `0 ${Spacing.XxxxLarge}px ${Spacing.XxLarge}px ${Spacing.XxxxLarge}px`};
`
